import { z } from "zod";

import { JavaCurrencyValue } from "../../../utils/currency";

const JavaCurrencyValueSchema: z.ZodType<JavaCurrencyValue> = z.object({
  currency: z.string(),
  amount: z.string(),
  decimalPoints: z.string(),
  displayAmount: z.string(),
});

const AirlineEntrySchema = z.object({
  airlineName: z.string(),
  amount: JavaCurrencyValueSchema,
  logoUrl: z.string().optional(),
});

const Top5AirlinesTransactionEntrySchema = z.object({
  truncatedDate: z.string().optional(),
  quarter: z.string(),
  month: z.string(),
  year: z.string(),
  airlines: z.array(AirlineEntrySchema),
});

export const Top5AirlinesTransactionsResultSchema = z.object({
  top5AirlinesTransactions: z.object({
    transactions: z.array(Top5AirlinesTransactionEntrySchema),
  }),
});

export type Top5AirlinesTransactionsResult = z.infer<
  typeof Top5AirlinesTransactionsResultSchema
>;
